/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Use_Own_Code_MessageInputs */

const en_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, you cannot invite yourself :(`)
};

const ar_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عذرًا، لا يمكنك دعوة نفسك :(`)
};

const de_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, du kannst dich nicht selbst einladen :(`)
};

const es_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo sentimos, no puedes invitarte a ti mismo :(`)
};

const fr_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désolé, vous ne pouvez pas vous inviter vous-même :(`)
};

const it_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiacente, non puoi invitare te stesso :(`)
};

const ja_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分自身を招待することはできません。`)
};

const ko_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`죄송해요, 자기 자신은 초대할 수 없어요 :(`)
};

const pt_br_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desculpe, você não pode convidar a si mesmo :(`)
};

const ru_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извините, нельзя пригласить самого себя :(`)
};

const th_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขออภัย คุณไม่สามารถเชิญตัวเองได้ :(`)
};

const tr_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üzgünüm, kendini davet edemezsin :(`)
};

const zh_cn_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抱歉，你无法邀请自己 :(`)
};

const zh_tw_use_own_code_message = /** @type {(inputs: Use_Own_Code_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抱歉，你無法邀請自己 :(`)
};

/**
* | output |
* | --- |
* | "Sorry, you cannot invite yourself :(" |
*
* @param {Use_Own_Code_MessageInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const use_own_code_message = /** @type {((inputs?: Use_Own_Code_MessageInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Use_Own_Code_MessageInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_use_own_code_message(inputs)
	if (locale === "ar") return ar_use_own_code_message(inputs)
	if (locale === "de") return de_use_own_code_message(inputs)
	if (locale === "es") return es_use_own_code_message(inputs)
	if (locale === "fr") return fr_use_own_code_message(inputs)
	if (locale === "it") return it_use_own_code_message(inputs)
	if (locale === "ja") return ja_use_own_code_message(inputs)
	if (locale === "ko") return ko_use_own_code_message(inputs)
	if (locale === "pt_br") return pt_br_use_own_code_message(inputs)
	if (locale === "ru") return ru_use_own_code_message(inputs)
	if (locale === "th") return th_use_own_code_message(inputs)
	if (locale === "tr") return tr_use_own_code_message(inputs)
	if (locale === "zh_cn") return zh_cn_use_own_code_message(inputs)
	return zh_tw_use_own_code_message(inputs)
});